export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Маркетинг',
        path: '/cases/marketing',
    },
];
export const bannerInfo = {
    img: '/images/pic/moscow-exchange/moscow-exchange.png',
    title: `Увеличили трафик в&nbsp;4&nbsp;раза для сайтов Московской биржи за&nbsp;5&nbsp;месяцев`,
    subtitle:
        'Рост трафика в&nbsp;4&nbsp;раза для сайтов finuslugi.ru и&nbsp;moex.com по&nbsp;приоритетным направлениям ' +
        'за&nbsp;счет комплексной стратегии, технологичного подхода к&nbsp;SEO, оптимизации контента, ' +
        'работы с&nbsp;юзабилити и&nbsp;ссылочного продвижения.',
    descriptions: [
        {
            name: 'Отрасль',
            details: 'Финансы',
        },
        {
            name: 'Услуги',
            details: 'SEO',
        },
        {
            name: 'Сроки',
            details: 'сентябрь 2023&nbsp;&mdash; январь 2024',
        },
    ],
    companyInfo: {
        company: 'Московская биржа и Финуслуги',
        companyLink: [
            {
                link: 'https://moex.com/',
                name: 'moex.com',
            },
            {
                link: 'https://finuslugi.ru/',
                name: 'finuslugi.ru',
            },
        ],

        // eslint-disable-next-line max-len
        text: `Московская биржа&nbsp;&mdash; единственная в&nbsp;России многофункциональная биржевая площадка 
        по&nbsp;торговле ценными бумагами, валютой, инструментами денежного рынка, производными инструментами 
        и&nbsp;товарами. Платформа &laquo;Финуслуги&raquo; создана по&nbsp;инициативе Банка России,
         чтобы сделать банковские и&nbsp;страховые продукты доступными для населения вне зависимости от&nbsp;региона 
         проживания.`,
        info: `RUWARD 2024 <br/> SEO-кейс года, 3 место`,
        icon: '/images/svg/moscow-exchange/ruward.svg',
    },
};
export const listStages = [
    {
        number: '1.',
        text:
            'Разработать комплексную стратегию, основанную на&nbsp;знании целевой аудитории, анализе' +
            ' конкурентов, репутации застройщика и&nbsp;понимания рынка.',
    },
    {
        number: '2.',
        text:
            'Определить гипотезы первого приоритета и&nbsp;посчитать по&nbsp;ним цену клика, ' +
            'количество показов, CTR, CR, процент качества лидов.',
    },
    {
        number: '3.',
        text: 'Запланировать количество кликов, бюджеты и&nbsp;стоимость лидов по&nbsp;каждой рекламной кампании.',
    },
];
export const solutionsList = [
    {
        header: '1. Технические характеристики',
        description:
            'Основная задача&nbsp;&mdash; проиндексировать сайт так, чтобы в&nbsp;поисковой базе был один уникальный ' +
            'URL с&nbsp;уникальными мета-тегами Title, Description и&nbsp;уникальным текстовым описанием.',
        solutionSteps: [
            {
                icon: '/images/png/solutionsSteps/bug.png',
                text:
                    'Устранили основные технические ошибки, которые мешали поисковым роботам максимально полно ' +
                    'сканировать сайт. Для улучшения индексации сайта поработали над улучшение XML-карты' +
                    ' и&nbsp;файлов robots.txt, исправили битые ссылки, устранили дублирование страниц.',
            },
            {
                icon: '/images/png/solutionsSteps/mobile.png',
                text:
                    'Оптимизировали метаданные, URL, проработали мета, чтобы заголовки были в&nbsp;последовательной ' +
                    'структуре, дали рекомендации по&nbsp;адаптивности под мобильные устройства, которые клиент ' +
                    'реализовал на&nbsp;своей стороне.',
            },
            {
                icon: '/images/png/solutionsSteps/cert.png',
                text:
                    'Настроили использование SSL сертификата, нашли ошибки краулинга, так как этот фактор может ' +
                    'негативно сказаться на&nbsp;позициях, трафике и&nbsp;видимости сайта в&nbsp;результатах поиска.' +
                    ' Проверили доступность JS-файлов и&nbsp;убедились, что они открыты для сканирования.',
            },
        ],
        sideText:
            'В&nbsp;2&nbsp;раза сократили количество дубликатов страниц. Изначально было 300 тысяч дублей ' +
            'из-за неоптимизированных мета-тегов.',
    },
    {
        header: '2. Работа с контентом',
        description:
            'За&nbsp;5&nbsp;месяцев работы над проектом написали более 300 уникальных текстов для посадочных ' +
            'страниц, которые четко описывают предлагаемые товары или услуги. Откорректировали текущие тексты, ' +
            'удалив избыточную информацию.',
        solutionSteps: [
            {
                icon: '/images/png/solutionsSteps/text.png',
                text:
                    'Анализировали выдачу, что ранжируется в&nbsp;топе запросов, далее составляли техзадание. ' +
                    'Контент на&nbsp;сайтах должен не&nbsp;только соответствовать интересам и&nbsp;потребностям' +
                    ' аудитории, но&nbsp;и&nbsp;быть доступным для быстрого и&nbsp;легкого поиска. Важен ' +
                    'не&nbsp;объем текста и&nbsp;плотность ключевых слов, а&nbsp;способность ответить на&nbsp;вопросы' +
                    ' пользователей.',
            },
            {
                icon: '/images/png/solutionsSteps/strategy.png',
                text:
                    'Для блога на&nbsp;Финуслугах разработали контентную стратегию с&nbsp;учетом требований для SEO ' +
                    'и&nbsp;семантики продвигаемых ресурсов.',
            },
        ],
    },
    {
        header: '3. Юзабилити',
        description:
            'Проанализировали, насколько сайты Московской биржи и&nbsp;Финуслуги дружелюбны и&nbsp;удобны ' +
            'по&nbsp;отношению к&nbsp;пользователям. Подготовили рекомендации для улучшения навигации, ' +
            'оптимизации процессов взаимодействия пользователя с&nbsp;сайтом (например, процесс покупки ' +
            'или подписки). Особое внимание уделили проработке мобильной верстки сайта и&nbsp;UX, чтобы контент ' +
            'сайта был легко доступен и&nbsp;на&nbsp;смартфонах.',
    },
    {
        header: '4. Ссылочное продвижение',
        description:
            'Цель, которую мы&nbsp;преследуем&nbsp;&mdash; это улучшение авторитета сайта в&nbsp;глазах ' +
            'поисковых систем, что положительно сказывается на&nbsp;его позициях в&nbsp;выдаче. Провели работы ' +
            'по&nbsp;получению качественных внешних ссылок на&nbsp;сайт из&nbsp;других источников. Сосредоточились ' +
            'на&nbsp;получении качественных и&nbsp;релевантных ссылок, а&nbsp;не&nbsp;на&nbsp;их&nbsp;количестве.',
    },
];

export const challengesList = [
    {
        title: 'Оптимизация под JavaScript',
        text:
            'На&nbsp;этапе аудита сайтов столкнулись с&nbsp;проблемой рендеринга сайта при включении/отключении JS. ' +
            'Критично эта проблема отражалась на&nbsp;мета-тегах. Наша задача&nbsp;&mdash; облегчить процесс' +
            ' сканирования контента и&nbsp;по&nbsp;возможности избегать проблем, которые часто возникают при' +
            ' обработке страниц, использующих JavaScript.',
    },
    {
        title: 'Большая структура сайтов',
        text:
            'Более 400К страниц на&nbsp;сайте Финуслуги и&nbsp;600К страниц на&nbsp;Московской бирже в&nbsp;индексе,' +
            ' что усложняло их&nbsp;мониторинг и&nbsp;переобход после внедрения изменения и&nbsp;исправления ошибок.' +
            ' Много посадочных страниц реализовано с&nbsp;использованием GET-параметров, что также вносило сложности ' +
            'в&nbsp;их&nbsp;оптимизацию.',
    },
    {
        title: 'Фродовый трафик',
        text:
            'В&nbsp;Яндекс Метрике увидели поток неестественного трафика. Это заходы из&nbsp;поисковых систем ' +
            'и&nbsp;прямые заходы с&nbsp;подозрительными характеристиками: очень мало отказов и&nbsp;при этом' +
            ' низкое среднее время на&nbsp;сайте, маленькая глубина просмотра. Мы&nbsp;фиксируем такие случаи,' +
            ' обсуждаем их&nbsp;с&nbsp;клиентом и&nbsp;предлагаем гипотезы по&nbsp;работе с&nbsp;такими ситуациями.',
        sideText:
            'На&nbsp;проекте столкнулись с&nbsp;накруткой поведенческих факторов, которые дали неестественную ' +
            'активность и&nbsp;повлияли на&nbsp;статистику.',
    },
];

export const listResults = [
    {
        title: 'в 3 – 4 раза',
        description: 'CPL в&nbsp;старых&nbsp;РК дороже нашего прогноза',
    },
    {
        title: '25%',
        description: 'рекламных кампаний не&nbsp;приносили лиды',
    },
];

export const listSolutionsMedia = [
    {
        description: 'Брендовые РК&nbsp;на&nbsp;Поиске и&nbsp;в&nbsp;РСЯ',
    },
    {
        description: 'РК&nbsp;по&nbsp;конкурентам на&nbsp;Поиске и&nbsp;в&nbsp;РСЯ',
    },
    {
        description: 'РК&nbsp;с&nbsp;геозависимыми запросами на&nbsp;Поиске и&nbsp;в&nbsp;РСЯ',
    },
    {
        description: 'Мастер кампании с&nbsp;автотаргетингом',
    },
];

export const listSolutionsMediaParagraf = [
    {
        description:
            'Также протестировали различные Look-alike аудитории, которые подобрали на&nbsp;основе клиентской базы ' +
            'застройщика.',
    },
    {
        description:
            'Результаты первых двух месяцев показали, что цена лида стала в&nbsp;2&nbsp;раза ниже от&nbsp;прошлых ' +
            'запусков. Хорошо себя показала стратегия на&nbsp;оптимизацию конверсий с&nbsp;использованием' +
            ' автотаргетинга. Но&nbsp;объем лидов был недостаточным.',
    },
    {
        description:
            'Для достижения запланированных амбициозных результатов решили изменить стратегию, чтобы увеличить ' +
            'количество лидов и&nbsp;сделать их&nbsp;дешевле.',
    },
];

export const listSolutionsPages = [
    {
        description:
            'Поисковые РК&nbsp;и&nbsp;РСЯ кампании с&nbsp;прямой и&nbsp;брендовой семантикой',
    },
    {
        description:
            'Поисковые РК&nbsp;с&nbsp;интересами, сегментами и&nbsp;семантикой, связанной с&nbsp;инвестициями',
    },
    {
        description: 'РСЯ кампании на&nbsp;премиум сегменты и&nbsp;интересы',
    },
];

export const listSolutionsParagraf = [
    {
        description:
            'Так как у&nbsp;сайта очень низкий процент конверсии, решили перевести&nbsp;РК на&nbsp;квиз. ' +
            'Это сразу&nbsp;дало результаты. Например, для премиального жилого комплекса использовали квиз ' +
            'из&nbsp;5&nbsp;блоков с&nbsp;акцентами на&nbsp;основные преимущества данного&nbsp;ЖК.',
    },
    {
        description: 'Мы&nbsp;тестировали различные гипотезы:',
    },
];

export const listSolutionsAnaliz = [
    {
        description:
            'Внедрили систему еженедельных аудитов РК. По&nbsp;результатам анализов принимались ' +
            'решения о&nbsp;корректировках&nbsp;РК, сменах стратегии, корректировках целей, ставок.',
    },
    {
        description:
            'Благодаря структурной работе PPC-команды и&nbsp;качественному менеджменту проекта ' +
            'за&nbsp;12&nbsp;месяцев нам удалось протестировать более 3000 гипотез по&nbsp;болям и&nbsp;мотивам ' +
            'аудитории, гео, различных УТП, вовремя осуществлять корректировки креативов, ' +
            'текстов&nbsp;и&nbsp;настроек на&nbsp;основе анализа результатов, найти максимально эффективные решения,' +
            'в&nbsp;принятии которых ' +
            'мы&nbsp;ориентировались на&nbsp;глубокую сквозную аналитику.',
    },
];

export const listSolutionsDifficulties = [
    {
        number: '1.',
        text: 'Большая внутренняя команда.',
    },
    {
        number: '2.',
        text: 'Много новых запусков рекламных кампаний.',
    },
    {
        number: '3.',
        text: 'Частая смена креативов, офферов по&nbsp;всем объектам строительства.',
    },
    {
        number: '4.',
        text: 'Большой объем аналитики и&nbsp;трудозатратные отчеты.',
    },
];

export const resultsList = [
    {
        projectTitle: 'Рост трафика на сайте moex.com',
        projectResults: [
            {
                title: '+162%',
                description: 'главная страница',
            },
            {
                title: '+122%',
                description: 'новости',
            },
            {
                title: '+77%',
                description: 'ход торгов',
            },
            {
                title: '+67%',
                description: 'срочный рынок',
            },
            {
                title: '+64%',
                description: 'валютная пара Доллар США/Рубль',
            },
        ],
    },
    {
        projectTitle: 'Рост трафика на сайте finuslugi.ru',
        projectResults: [
            {
                title: '+423%',
                description: 'микрозаймы',
            },
            {
                title: '+125%',
                description: 'рейтинг банков',
            },
            {
                title: '+51%',
                description: 'вклады',
            },
            {
                title: '+40%',
                description: 'журнал',
            },
        ],
    },
];
export const commonResultsList = [
    {
        id: '1',
        text: 'Оптимизировали рендеринг под JavaScript',
    },
    {
        id: '2',
        text: 'Проработали метаданные, URL и&nbsp;убрали дубликаты',
    },
    {
        id: '3',
        text: 'Написали 300+ уникальных текстов для посадочных страниц',
    },
    {
        id: '4',
        text: 'Создали контент-стратегию для блога',
    },
    {
        id: '5',
        text: 'Улучшили навигацию и сценарии взаимодействия',
    },
    {
        id: '6',
        text: 'Проработали мобильную верстку сайта и&nbsp;UX',
    },
];

export const listSteps = [
    { icon: '/images/svg/moscow-exchange/steps/glass.svg', text: 'Техническое SEO' },
    { icon: '/images/svg/moscow-exchange/steps/arrow.svg', text: 'Контентное развитие' },
    { icon: '/images/svg/moscow-exchange/steps/mobile.svg', text: 'Работа с юзабилити' },
    { icon: '/images/svg/moscow-exchange/steps/chain.svg', text: 'Ссылочное продвижение' },
];

export const crewList = [
    {
        crewItemTitle: 'Смоленцева Виктория',
        crewItemSubtitle: 'Старший менеджер проектов',
    },
    {
        crewItemTitle: 'Левченко Анна',
        crewItemSubtitle: 'Менеджер проекта',
    },
    {
        crewItemTitle: 'Бурлуцкий Сергей',
        crewItemSubtitle: 'Head of SEO',
    },
    {
        crewItemTitle: 'Бакалова Анна',
        crewItemSubtitle: 'SEO-тимлид',
    },
    {
        crewItemTitle: '6 SEO-специалистов',
    },
];
